import { Divider, Typography } from "@mui/material";
import { Box } from "@mui/system";

import useBreakpoints from "../hooks/useBreakpoints";
import { ReactComponent as AgiIcon } from "../assets/icons/agi.svg";
import { getAugmentedStyle } from "../utils/augmentedStyles";

const EST_APR = '31.62%';
const TVL = '$811,155.22';

const styles = {
  perfCardTitle: {
    fontSize: { xxs: "14px", sm: "18px" },
  },
  perfCardAmount: {
    fontFamily: "Teko, sans-serif",
    fontSize: { xxs: 36, md: 50, lg: 60 },
    fontWeight: 400,
    lineHeight: { xxs: 1, sm: 0.9 },
    alignSelf: 'end',
  }
}

function SingleHeading() {
  const downXs = useBreakpoints("down", "xs");

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        height: "37px",
        mt: { xxs: "48px", sm: "60px" },
        mb: { xxs: "16px", sm: "36px" }
      }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center"
        }}>
        <AgiIcon
          style={{
            width: downXs ? "24px" : "32px"
          }}
        />
        <Typography
          sx={{
            ml: "10px",
            fontWeight: { xxs: 400, sm: 500 },
            fontSize: { xxs: "16px", sm: "20px" },
            lineHeight: "21px"
          }}>
          $AGI Pool Performance
        </Typography>
      </Box>
    </Box>
  );
}

export default function PreAgiPoolBox() {
  return (
    <Box>
      <Box className="completed-box" sx={{
        mt: { xxs: "48px", md: "44px" }
      }}>
        <Box className="info-title" sx={{
          fontSize: { xxs: "16px", md: "20px" },
          lineHeight: "1.5",
          fontWeight: 500,
          mb: 2
        }}>
          <Divider sx={{ display: { xxs: "none", md: "flex" } }}>Previous $AGI Pool Round Successfully Completed</Divider>
          <Box sx={{ display: { xxs: "block", md: "none" }, textAlign: 'center' }} >Previous $AGI Pool Round<br/> Successfully Completed</Box>
        </Box>
        <Box className="info-tips" sx={{
          textAlign: 'center',
          maxWidth: '960px',
          margin: '0 auto',
          fontSize: { xxs: "14px", md: "16px" },
          opacity: 0.5
        }}>The previous $AGI Pool round has concluded. All staked $AGI tokens are returned to users’ Delysium Accounts. This doesn't affect $AGI rewards under vesting, which will continue as scheduled. To join the new round, use the $AGI tokens in your Delysium Account.</Box>
      </Box>

      <SingleHeading />

      <Box sx={{
        display: 'flex',
        flexDirection: { xxs: 'column', sm: "row" },
        gap: { xxs: "12px", sm: "20px" }
      }}>
        <Box
          data-augmented-ui="tl-clip border"
          style={getAugmentedStyle({
            color: "#323232"
          })}
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'space-between',
            minHeight: "90px",
            height: { xxs: '100px', sm: "182px" },
            padding: { xxs: '10px 26px', sm: "24px 40px" },
          }}
        >
          <Box sx={styles.perfCardTitle}>
          Ave. APR
          </Box>
          <Box sx={styles.perfCardAmount}>
          {EST_APR}
          </Box>
        </Box>
        <Box
          data-augmented-ui="tl-clip border"
          style={getAugmentedStyle({
            color: "#323232"
          })}
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'space-between',
            minHeight: "90px",
            height: { xxs: '100px', sm: "182px" },
            padding: { xxs: '10px 26px', sm: "24px 40px" },
          }}
        >
          <Box sx={styles.perfCardTitle}>
          TVL
          </Box>
          <Box sx={styles.perfCardAmount}>
          {TVL}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
